export const environment = {
    production: false,
    apiBaseV1: 'https://al-app-int-online-goh-admintoolapi-test.azurewebsites.net/api/v1/',
    apiBaseV2: 'https://al-app-int-online-goh-admintoolapi-test.azurewebsites.net/api/v2/',
    apiPrevBaseUrl: 'https://al-app-int-online-goh-admintoolapi-dev.azurewebsites.net/api/v1/',
    adminToolApiClientId: '4480846a-72be-40a6-aaf9-1106235c1226',
    adminToolClientId: '093e3d84-178c-4ec7-8e8d-a1c44d298cd3',
    adminToolTenentId: 'ed5d5f47-52dd-48af-90ca-f7bd83624eb9',
    env: 'test',
    prevenv: 'dev',
    d365EnricherHost: 'https://api-alfalaval-test.azure-api.net/api/v1/d365fo/D365FOLookupService',
    httpDestinationDefaultQueue: 'al-goh-transfer-send-http',
    managedIdentity: {
        name: 'al-uai-int-online-goh-test',
        clientId: '4cd47225-603a-4dd9-8b36-c40392167d56'
    },
    ediIdentifiers: {
        as2: 'ALFALAVAL_TEST',
        x12: 'AL_X12_TEST',
        edifact: 'ALFALAVAL_EDI_TEST',
    },
    azure: {
        subscriptionId: '582f607a-5495-4851-a4e7-62d71de2156b',
        resourceGroup: 'al-rg-int.goh-test',
    },
    resources: {
        appInsights: {
            componentName: 'al-ai-int-online-goh-test'
        },
        logicApps: {
            siteName: 'al-las-int-online-goh-test'
        }
    }
};
